export default {
    BLUE:  0,
    BLUE_RED: 1,
    BLUE_YELLOW: 2, 
    BLUE_GREEN: 3,
    RED: 4,
    RED_BLUE: 5,
    RED_YELLOW: 6, 
    RED_GREEN: 7,
    YELLOW: 8,
    YELLOW_BLUE: 9,
    YELLOW_RED: 10,
    YELLOW_GREE: 11,
    GREEN: 12,
    GREEN_BLUE: 13,
    GREEN_RED: 14,
    GREEN_YELLOW: 15 
}